import { render, staticRenderFns } from "./ListDtc.vue?vue&type=template&id=33598cbe&scoped=true&"
import script from "./ListDtc.vue?vue&type=script&lang=js&"
export * from "./ListDtc.vue?vue&type=script&lang=js&"
import style0 from "./ListDtc.vue?vue&type=style&index=0&id=33598cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33598cbe",
  null
  
)

export default component.exports